import type { RezaSwitcherType } from '@gov-nx/core/hooks';
import { Button, ContentLayout } from '@gov-nx/ui/web';
import { RezaChangeModal } from './RezaChangeModal';
import { RezaPersonTable } from './RezaPersonTable';
import { Skeleton } from '../../Skeleton/Skeleton';

export const RezaSwitcher = ({
	permissions,
	description,
	isRezaSwitcherEnabled,
	rezaPersonTableProps,
	rezaChangeModalProps,
	rezaButtonProps,
}: RezaSwitcherType) => {
	const { implicitAllowed, explicitAllowed } = permissions;

	if (!isRezaSwitcherEnabled) {
		return null;
	}

	if (!implicitAllowed && !explicitAllowed) {
		return (
			<ContentLayout>
				<RezaPersonTable {...rezaPersonTableProps} />
			</ContentLayout>
		);
	}

	return (
		<ContentLayout>
			<p className="text-(--text-secondary)">{description}</p>
			<RezaPersonTable {...rezaPersonTableProps} />
			{/*
			 * Show the CTA whenever it is needed — including the recovery case
			 * where a REZA is already selected (isVisible via activeSwitcherReza)
			 * but the eligible list is still loading. The change modal handles the
			 * loading list internally (its own skeletons), so the button stays
			 * reachable. Fall back to the skeleton only while the button is not yet
			 * needed but the list is still loading.
			 */}
			{rezaButtonProps.isVisible ? (
				<>
					<Button
						onClick={rezaButtonProps.onModalOpen}
						isDisabled={rezaButtonProps.isRezaButtonDisabled}
						color="primary"
						type="base">
						{rezaButtonProps.text}
					</Button>
					<RezaChangeModal {...rezaChangeModalProps} />
				</>
			) : rezaButtonProps.isLoading ? (
				<Skeleton
					width="30%"
					height="40px"
				/>
			) : null}
		</ContentLayout>
	);
};
